module.exports = __webpack_public_path__ + "img/phone-call.9e5c3213.svg";